import Theme from "../theme";
import IconPackage from "./icons";

const vitat: Theme = {
	colors: {
		backgroundColor: "#F0F1F5",
		primary: "#4CA15D",
		secondary: "#5A3B94",

		"text-primary": "#000000",
		"text-secondary": "#002b49",

		backgroundCancelado: "#E6E6E6",
		textCancelado: "#212121",

		backgroundFinalizado: "#424242",
		textFinalizado: "#FFFFFF",

		backgroundAgendado: "#0A2F2A",
		textAgendado: "#FFFFFF",

		backgroundConfirmado: "#3a87ad",
		textConfirmado: "#FFFFFF",

		backgroundEsperando: "#ffaa00",
		textEsperando: "#FFFFFF",

		backgroundNaoCompareceu: "#f76397",
		textNaoCompareceu: "#FFFFFF",

		backgroundReagendado: "#840000",
		textReagendado: "#FFFFFF",

		backgroundAndamento: "#3f3f3f",
		textAndamento: "#FFFFFF",

		backgroundSalaDisponivel: "#4CA15D",
		textSalaDisponivel: "#FFFFFF",

		// Exclusive colors for Vitat App
		blackVitat: "#212121",
		whiteVitat: "#FFFFFF",
		greenVitat: "#4CA15D",
		yellowVitat: "#F4B36F", 
		lightGrayVitat: "#E6E6E6",
		brownVitat: "#A89B91",
	},
	icons: IconPackage,
};

export default vitat;
